<template>
  <sidebar-old v-if="!isFourthVersion" />
  <sidebar-new v-else />
</template>


<script>
import { createNamespacedHelpers } from 'vuex';
import { axiosClient } from '../../../core/services/http.service';
import SidebarOld from './SidebarOld.vue';
import SidebarNew from './SidebarNew.vue';

const { mapState: mapStateApp } = createNamespacedHelpers('app');

export default {
  name: 'Sidebar',
  components: {
    SidebarOld,
    SidebarNew,
  },
  computed: { 
    ...mapStateApp(['isFourthVersion']),
  },
  async mounted() {
    const { success, body } = await axiosClient.get('/api/version');
    if (success) {
      this.version = `${body.version}`;
      this.versionDate = `${body.updateDate}`;
    }
  },
};
</script>